import Vue from 'vue'
import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import './styles/element-variables.scss'
import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters
import * as GillionUI from 'ec-light-vue'

import moment from 'moment'
Vue.prototype.$moment = moment

// 引入echarts图表
import echarts from 'echarts'

import coreMethods from './utils/core-methods'
import systemConfig from '@/config/systemConfig'
import daoServiceUtils from './utils/daoServiceUtils'

import i18n from './lang' // internationalization

import preventReClick from './directive/preventReClick';
Vue.use(preventReClick);
import { Uploader } from 'ec-light-vue';
// 表格自适应
// import tableAdaptation from  './tableAdaptation.JS'
// Vue.prototype.$tableAdaptation = tableAdaptation

// 数据字典
import getDataDictionary from './utils/getDataDictionary'
Vue.prototype.$getDataDictionary = getDataDictionary

Uploader.UploaderStrategy.setConfig({
  ctx: '/api/cts-file-service',
  urls: {
    uploadPrefix: '/cloud/filesystem/uploadFile/',
    downloadPrefix: '/cloud/filesystem/downloadFile/',
    deletePrefix: '/cloud/filesystem/deleteFile/',
    getStrategyPrefix: '/cloud/filesystem/getStrategy/',
    getFileInfosByStrategyId: '/cloud/filesystem/getFileInfos/',
    getSnapshotUploadPrefix: '/cloud/filesystem/uploadSnapshot/'
  }
})
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}


/* Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  locale: enLang // 如果使用中文，无需设置，请删除
}) */

Vue.use(GillionUI, {
  /*
    加载按钮权限，页面的created中调用this.$permissions.loadPermissions(this.$route.path);
  */
  //  loadPermitionMethod: async function (path) {
  //   let pageBtn = [];
  //   await loadPageBtn(path).then(function (res) {
  //     pageBtn = res.btnList;
  //     console.log('pageBtn', pageBtn);
  //   });
  //   return {
  //     permits: pageBtn,
  //   };
  // },
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value),
  config: {
    focusOnClear: true,
    dictionary: {
      url: '/common/dictionary/queryDictRows'
    },
    select: {
      filterable: true,
      popperAppendToBody: true
    },
    associate: {
      defaultFirstOption: true,
      popperAppendToBody: true,
      autoSelectOnlyOption: false,
      allowCreateWhenNotEmpty: true,
      keepInputValue: true,
      initSearchKeepValue: true,
      disableClickHideMenu: true,
      focusSelect: true
    },
    form: {
      messageType: 'tooltip'
    },
    hotTable: {
      ctx: '/web/auth',
      multipleEditorValueSeparator: ';'
    },
    permissions: {
      url: '/dev-api/auth/system/security/getSessionAttrsAndNoPermits'
    }
  }
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$coreMethods = coreMethods
Vue.prototype.$systemConfig = systemConfig
Vue.prototype.$daoServiceUtils = daoServiceUtils


new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
